import { render, staticRenderFns } from "./DatabaseCard.vue?vue&type=template&id=12723feb&scoped=true"
import script from "./DatabaseCard.vue?vue&type=script&lang=js"
export * from "./DatabaseCard.vue?vue&type=script&lang=js"
import style0 from "./DatabaseCard.vue?vue&type=style&index=0&id=12723feb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12723feb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VIcon,VProgressLinear})
